import React from "react";
import {connect} from 'react-redux';
import {performanceApiRequest,performanceParameterChange,performanceMonthChange,attributeApiRequest} from '../actions';
import {Bar} from 'react-chartjs-2';
import MonthPickerInput from 'react-month-picker-input'
import Select from 'react-select';




const months = ['January','February','March','April','May','June','July','August','September','October','November','December' ];




class Performance extends React.Component {
    constructor(props) {
        super(props);
        this.state = {selectedAttribute:'',oldAttribute:'',attribute:[]}
        this.parameterChange = this.parameterChange.bind(this);
        this.monthChange = this.monthChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getNewPerformance = this.getNewPerformance.bind(this);
    }
    componentDidMount() {
        this.props.onAttributeApiRequest();
    }

   parameterChange(selectedOption) {
        this.props.onParameterChange(selectedOption,this.props.performance);
        this.getNewPerformance();
   }


   handleChange(selectedOption) {
       this.setState({'selectedAttribute':selectedOption,oldAttribute:this.state.selectedAttribute});
       this.props.onParameterChange({value: '', label: ""},this.props.performance);
       this.getNewPerformance(selectedOption,'attribute');
   }

   monthChange(maskedValue, year, month) {
       this.props.onMonthChange(month+1,year,this.props.performance);

   }
   getNewPerformance(val=null,type=null) {
       let pDatas = this.props.performance.performance
       let selectedA = {}
       if(type === 'attribute') {
        selectedA = val
       } else {
        selectedA = this.state.selectedAttribute
       }
       let sentData = {oldAttribute:this.state.oldAttribute,attribute_id:selectedA,month:pDatas.month,year:pDatas.year,parameter_id:pDatas.parameter_selected.value}
       this.setState({oldAttribute:selectedA});
       this.props.onApiRequest(sentData);
   }

   componentDidUpdate() {
        if(typeof this.props.attribute.attribute !== 'undefined' && this.state.selectedAttribute==='') {
            let aList = this.props.attribute.attribute;
            let aListItem = {}
            let attributeOptions = []
            for(let ij=0;ij< aList.length;ij++) {
                aListItem = {value: aList[ij].id, label: aList[ij].name}
                attributeOptions.push(aListItem)
                if(ij === 0 && this.state.selectedAttribute==='') {
                    this.setState({selectedAttribute:aListItem});
                }
            }
            this.setState({attribute:attributeOptions});
            setTimeout(function() {
                let search = window.location.search;
                let params = new URLSearchParams(search);
                let month = params.get('m');
                let year = params.get('y');

                if(month === null || month === '' ) {
                    month = new Date().getMonth();
                }

                if(year === null || year === '' ) {
                    year = new Date().getFullYear();
                }
                let detail = {month:month,year:year,oldAttribute:this.state.oldAttribute,attribute_id:this.state.selectedAttribute};
                this.setState({oldAttribute:this.state.selectedAttribute});
                this.props.onApiRequest(detail);
            }.bind(this),1000)

        }
   }

  render() {
    let labels = [];
    let my_score = [];
    let batch_avg = [];
    let batch_best = [];
    let player_name = '';
    let parameterOptions = [];
    let parameterSelected = null;
    let attributeOptions = [{value: 1, label: 'Footwork'}];
    let attributeSelected = {value: 1, label: 'Footwork'};

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let month = params.get('m');
    let year = params.get('y');


    if(month === null || month === '' ) {
        month = new Date().getMonth();
    }

    if(month === null || month === '' ) {
        year = new Date().getFullYear();
    }



    if(typeof this.props.performance.performance !== 'undefined') {
        let gData = this.props.performance.performance.graph;
        player_name = this.props.performance.performance.player_name;
        parameterSelected = this.props.performance.performance.parameter_selected;
        month = this.props.performance.performance.month-1;
        year = this.props.performance.performance.year;
        for(let ik=0;ik<gData.length;ik++) {
            labels.push(months[gData[ik].month-1]);
            my_score.push(gData[ik].self_score)
            batch_avg.push(gData[ik].avg_score)
            batch_best.push(gData[ik].best_score)
        }

        let pData = this.props.performance.performance.parameters;
        for(let il=0;il<pData.length;il++) {
            parameterOptions.push({ value: pData[il].parameter_id, label: pData[il].name });
        }
    }
    const data = {
      //labels: ['a','b','c','d','e'],
      labels: labels,
      datasets: [
        {
          label: 'My Score',
          backgroundColor: 'rgba(130, 124, 249,1)',
          borderColor: 'rgba(130, 124, 249,1)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(130, 124, 249,1)',
          hoverBorderColor: 'rgba(130, 124, 249,1)',
          //data: [25,68,99,35,12]
          data: my_score
        },
        {
          label: 'Batch Average',
          backgroundColor: 'rgba(253, 181, 59,1)',
          borderColor: 'rgba(253, 181, 59,1)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(253, 181, 59,1)',
          hoverBorderColor: 'rgba(253, 181, 59,1)',
          //data: [76,54,81,65,57]
          data: batch_avg
        },
         {
           label: 'Batch Best',
           backgroundColor: 'rgba(101, 225, 140,1)',
           borderColor: 'rgba(101, 225, 140,1)',
           borderWidth: 1,
           hoverBackgroundColor: 'rgba(101, 225, 140,1)',
           hoverBorderColor: 'rgba(101, 225, 140,1)',
           //data: [32,66,77,45,81]
           data: batch_best
         }
      ]
    };
let options = {
    scales: {
        xAxes: [{
            barPercentage: 0.5,
            categoryPercentage: 0.9,
            maxBarThickness: 22,
            barThickness: 25,
            gridLines: {
              display: false
            },

        }],
        yAxes: [{
            display: true,
            ticks: {
                suggestedMax: 100,
                beginAtZero: true,
                //padding: 20,
                stepSize:20
                        //labelOffset: 20,

            },
                //scaleSteps : 6,
                               // scaleStepWidth : 20,
                                //scaleStartValue : 0,
              gridLines: {
                  drawTicks: false,
                  display: false
                },
        }]
    }
};

      let searchStyle = {margin: '31px'};



    return (  <div>
                    <div className="row">
                      <div className="col-sm-3">
                        <label>Month</label>
                        <MonthPickerInput
                          year={year}
                          month={month}
                          onChange={this.monthChange}
                          closeOnSelect={true}
                        />
                      </div>
                      <div className="col-sm-3">
                        <label>Attribute</label>
                        <div>
                            <Select
                                value={this.state.selectedAttribute}
                                onChange={this.handleChange}
                                options={this.state.attribute}
                              />
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <label>Parameter</label>
                        <div>
                            <Select
                                value={parameterSelected}
                                onChange={this.parameterChange}
                                options={parameterOptions}
                              />
                        </div>
                      </div>

                      <div className="col-sm-3">
                          <button onClick={this.getNewPerformance} style={searchStyle} className="btn-primary btn">Search</button>
                       </div>

                    </div>

                    <br></br>

                      <h2>{player_name} VS Batch</h2>
                      <Bar
                        data={data}
                           height={50}
                           width={100}
                        options={options}
                      />
                    </div>

                    )
  }
}



const mapStateToProps = (state,props) => {
  return {
    performance: state.performance,
    attribute: state.attribute
  }
}
const mapActionsToProps =  {
      onApiRequest : performanceApiRequest,
      onParameterChange : performanceParameterChange,
      onAttributeApiRequest : attributeApiRequest,
      onMonthChange : performanceMonthChange
}
export default connect(mapStateToProps,mapActionsToProps) (Performance);



